function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.906,11.349l-1.9,1.94L6.02,7.4A1.144,1.144,0,0,0,4.91,6.264,1.122,1.122,0,0,0,3.8,7.4l-.008,5.9-1.9-1.942a1.093,1.093,0,0,0-1.568,0,1.152,1.152,0,0,0,0,1.6l3.184,3.254a1.938,1.938,0,0,0,2.784,0l3.183-3.254a1.152,1.152,0,0,0,0-1.6A1.093,1.093,0,0,0,7.906,11.349Z",
  transform: "translate(0 1.204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2,3.507,12.949.324a1.152,1.152,0,0,0-1.6,0,1.093,1.093,0,0,0,0,1.568l1.94,1.9-5.87-.01A1.146,1.146,0,0,0,6.281,4.889,1.122,1.122,0,0,0,7.414,6l5.875.01-1.943,1.9a1.093,1.093,0,0,0,0,1.568,1.152,1.152,0,0,0,1.6,0L16.2,6.292a1.939,1.939,0,0,0,0-2.785Z",
  transform: "translate(1.207)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.252,5.337a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,4.252,5.337Z",
  transform: "translate(0.627 0.624)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.252,2.205a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,4.252,2.205Z",
  transform: "translate(0.627 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.1,5.337A1.1,1.1,0,1,0,0,4.234,1.1,1.1,0,0,0,1.1,5.337Z",
  transform: "translate(0 0.624)"
}));

function SvgImgResize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgResize);
export default __webpack_public_path__ + "static/media/img_resize.c6e71ba5.svg";
export { ForwardRef as ReactComponent };